export * from './total-price-bar.component';
